<template>
  <div class="page__details">
    <!-- <div class="page__details_div"> -->
    <div class="head__component_navigation_div">
      <div class="head-title-left">
        <div class="head__left_component_text" :lines="undefined">
          {{ head__left_component_text }}
        </div>
        <div class="head__center_componentname_text" :lines="undefined">
          组件名称：
          {{ component.title }}
        </div>
        <div class="head__center_componentname_text" :lines="undefined">
          symbolID:
          {{ component.symbolId }}
        </div>
        <div class="head__center_componentname_text" :lines="undefined">
          <a-popover placement="bottom" title="组件位置:">
            <template slot="content">
              <!-- <span></span> -->
              {{ componentRoute }}
            </template>
            <span>组件位置:</span>
            <a-icon
              @click="copy()"
              style="font-size: 20px; color: #999999"
              type="copy"
            />
          </a-popover>
        </div>
        <div class="head__author_text" :lines="undefined">
          作者：
          {{ component.realName }}
        </div>
        <div class="head__upload_time_text" :lines="undefined">
          上传时间：
          {{ component.createTime }}
        </div>
        <div class="head__praise_div" @click.stop="praiseAdd">
          <img
            class="head__praise_icon"
            :src="
              require(msg.praiseflag
                ? '@/assets/component/detail/imgpraise.png'
                : '@/assets/component/detail/praise.png')
            "
            alt=""
          />
          <span
            class="head__praise_num"
            :lines="undefined"
            :class="{ Active: !msg.praiseflag }"
          >
            {{ msg.praiseNum }}
          </span>
        </div>
        <div class="head__download_div" @click.stop="downloadAdd">
          <img
            class="head__download_img"
            :src="
              require(msg.downloadflag
                ? '@/assets/component/detail/img_32417_0_5.png'
                : '@/assets/component/detail/download.png')
            "
            alt=""
          />
          <span
            class="head__download_num"
            :lines="undefined"
            :class="{ Active: !msg.downloadflag }"
          >
            {{ msg.downloadNum }}
          </span>
        </div>
      </div>
      <a-button type="primary" class="return-button" @click="returnClick">
        返回
      </a-button>
    </div>
    <a-row style="background-color: #e5e5e5">
      <a-col :span="24">
        <div class="body__content_div">
          <div class="body__left_select_div">
            <div class="body__select_iphone_div">
              <div class="body__iphone_div">
                <a-dropdown :trigger="['click']" class="body__format_text">
                  <a
                    class="ant-dropdown-link"
                    @click="(e) => e.preventDefault()"
                  >
                    {{ sllectPhone }}
                    <a-icon type="down" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                      v-for="(item, phoneIndex) in phoneList"
                      :key="phoneIndex"
                      @click="selectPhone(item)"
                    >
                      <a href="javascript:;">{{ item.phoneName }}</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </div>
              <div class="body__proportion_div">
                <span class="body__proportion_small_text" :lines="undefined">
                  {{ body__proportion_small_text }}
                </span>
                <span class="body__take_text" :lines="undefined">
                  {{ body__take_text }}
                </span>
                <span class="body__proportion_big_text" :lines="undefined">
                  {{ body__proportion_big_text }}
                </span>
              </div>
              <!-- 百分比 -->
              <div class="percentage">
                <a-dropdown :trigger="['click']" class="body__format_text">
                  <a
                    class="ant-dropdown-link"
                    @click="(e) => e.preventDefault()"
                  >
                    {{ percent + "%" }}
                    <a-icon type="down" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                      v-for="(
                        itemPercentage, percentageIndex
                      ) in percentageList"
                      :key="percentageIndex"
                      @click="selectPercentage(itemPercentage)"
                    >
                      <a href="javascript:;">{{
                        itemPercentage.percent + "%"
                      }}</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </div>
            </div>
            <!-- <div class="body__left_empty" /> -->
            <div :style="widthImgDiv" class="bigImgDiv">
              <img
                style="max-width: 100%; max-height: 100%"
                class="bigImg"
                :src="component.bigImg"
                alt=""
              />
            </div>
          </div>
          <div class="body__right_select_div">
            <div class="title-head">
              <div class="edit-configure">
                <!-- <a-button :size="size">文字配置</a-button> -->
              </div>
              <div class="body__format_div">
                <a-dropdown :trigger="['click']" class="body__format_text">
                  <a
                    class="ant-dropdown-link"
                    @click="(e) => e.preventDefault()"
                  >
                    {{ selectFrameWork.name }}
                    <a-icon type="down" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item
                      v-for="framework in frameworkList"
                      :key="framework.id"
                      @click="changeFrameWork(framework)"
                    >
                      <span>{{ framework.name }}</span>
                    </a-menu-item>
                    <!-- <a-menu-item key="1">
                    <a href="javascript:;">React代码</a>
                  </a-menu-item>
                  <a-menu-item key="3">
                    <a href="javascript:;">Taro代码</a>
                  </a-menu-item> -->
                  </a-menu>
                </a-dropdown>
              </div>
              <div class="edit-configure">
                <a-button
                  v-if="component.type == 1"
                  class="back-color"
                  style="background-color: white"
                  @click="editPage(component.id)"
                  >编辑页面</a-button
                >
                <!-- <a-button v-if="component.type == 1" @click="editPage(component.id)" class="back-color"
                  >编辑页面</a-button> -->
                <a-button v-if="component.type == 0" @click="snapshot(component.id)" class="back-color"
                  >生成截图</a-button
                >
                <a-button @click="showModal" class="back-color"
                  >框架管理</a-button
                >
              </div>
            </div>

            <!-- <div class="body__right_empty" /> -->
            <div class="body__index_div">
              <div class="tags-class">
                <div v-for="tag in tags" :key="tag.id">
                  <a-input
                    v-if="tag.inputVisible"
                    ref="input"
                    type="text"
                    size="small"
                    :style="{ width: '78px' }"
                    :value="inputValue"
                    @change="tagInputChange"
                    @blur="tagInputConfirm(tag)"
                    @keyup.enter="tagInputConfirm(tag)"
                  />
                  <a-tag
                    v-else
                    :closable="
                      tag.name !== 'index.vue' && tag.name !== 'README.md'
                    "
                    @click="changeTag(tag)"
                    @close="() => handleClose(tag)"
                    @dblclick="showtagInput(tag)"
                    :class="itemIndex == tag.id ? 'selectClassceshi' : ''"
                    class="tag-class"
                  >
                    {{ tag.name }}
                  </a-tag>
                </div>
                <a-input
                  class="ant-tag"
                  v-if="inputVisible"
                  ref="input"
                  type="text"
                  size="small"
                  style="font-size: 14px; width: 78px"
                  :value="inputValue"
                  @change="handleInputChange"
                  @blur="handleInputConfirm"
                />
                <a-tag
                  v-if="!inputVisible && component.type == '0'"
                  style="
                    background: #fff;
                    font-size: 14px;
                    width: 80px;
                    color: rgba(0, 0, 0, 0.85);
                  "
                  @click="showInput"
                  class="add_tag-style"
                >
                  <a-icon type="plus" /> 新建
                </a-tag>
              </div>
              <a-button
                @click="complectClick"
                class="button-complete"
                type="primary"
                >保存</a-button
              >
            </div>
            <codemirror
              style="width: 100%; margin-bottom: 30px"
              v-model="selectTag.content"
              :options="cmOption"
              class="code-mirror"
              @ready="onCmReady3"
              @focus="onCmFocus"
              @input="onCmCodeChange"
              ref="myCmGenerate"
            ></codemirror>
          </div>
        </div>
      </a-col>
    </a-row>

    <!-- </div> -->
    <!-- 弹窗内容 -->
    <a-modal
      title="框架管理"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :footer="null"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div class="addheader">
        <a-cascader 
          :display-render="displayRender"
          placeholder="请选择项目框架" 
          changeOnSelect
          :fieldNames="{label: 'name', value: 'id', children: 'children'}"
          :options="frameworkOptions" @change="setFrameWork"/>
        <a-button type="primary" class="editable-add-btn" @click="handleAdd">
          新增
        </a-button>
      </div>
      
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="frameworkList"
        bordered
      >
        <template v-for="col in ['name']" :slot="col" slot-scope="text, record">
          <div :key="col">
            <a-input
              v-if="record.editable"
              style="margin: -5px 0"
              :value="text"
              @change="(e) => handleChange(e.target.value, record.id, col)"
            />
            <template v-else>
              {{ text }}
            </template>
          </div>
        </template>
        <template slot="operation" slot-scope="text, record">
          <div class="editable-row-operations">
            <!-- <span v-if="record.editable">
              <a @click="() => saveFrameWork(record.id)">保存</a> |
              <a-popconfirm
                title="是否保存?"
                @confirm="() => cancelFrameWork(record.id)"
              >
                <a>取消</a>
              </a-popconfirm>
            </span> -->
            <span>
              <a
                style="color: #2878ff"
                @click="() => deleteFrameWork(record.id)"
                >删除</a
              >
            </span>
          </div>
        </template>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
// import MonacoEditor from 'vue-monaco-editor'
// import MonacoEditor from 'vue-monaco'
import { codemirror } from "vue-codemirror";
import "codemirror/mode/javascript/javascript.js";
import "codemirror/lib/codemirror.css";
// require active-line.js
import "codemirror/addon/selection/active-line.js";
// styleSelectedText
import "codemirror/addon/selection/mark-selection.js";
// hint
import "codemirror/addon/hint/show-hint.js";
import "codemirror/addon/hint/sql-hint.js";
import "codemirror/addon/hint/show-hint.css";
import "codemirror/addon/hint/javascript-hint.js";
// highlightSelectionMatches
import "codemirror/addon/scroll/annotatescrollbar.js";
import "codemirror/addon/search/matchesonscrollbar.js";
import "codemirror/addon/search/match-highlighter.js";
// keyMap
import "codemirror/mode/clike/clike.js";
import "codemirror/mode/sql/sql.js";
import "codemirror/addon/edit/matchbrackets.js";
import "codemirror/addon/comment/comment.js";
import "codemirror/addon/dialog/dialog.js";
import "codemirror/addon/dialog/dialog.css";
import "codemirror/addon/search/searchcursor.js";
import "codemirror/addon/search/search.js";
import "codemirror/keymap/sublime.js";
// foldGutter
import "codemirror/addon/fold/foldgutter.css";
import "codemirror/addon/fold/brace-fold.js";
import "codemirror/addon/fold/comment-fold.js";
import "codemirror/addon/fold/foldcode.js";
import "codemirror/addon/fold/foldgutter.js";
import "codemirror/addon/fold/indent-fold.js";
import "codemirror/addon/fold/markdown-fold.js";
import "codemirror/addon/fold/xml-fold.js";
// 编辑的主题文件
import "codemirror/theme/monokai.css";
import "codemirror/theme/base16-light.css";
import "codemirror/theme/solarized.css";

import _ from "lodash";
import frameworkApi from "@/request/api-manager/framework.js";
import codeApi from "@/request/api-manager/code.js";
import viewCodeExtApi from "@/request/api-manager/viewCodeExt.js";
// import * as monaco from 'monaco-editor';

// 获取机型尺寸
import projectApi from "@/request/api-manager/project.js";
import componentApi from "@/request/api-manager/component.js";
const columns = [
  {
    title: "名称",
    dataIndex: "name",
    scopedSlots: { customRender: "name" },
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
  },
];

export default {
  components: {
    codemirror,
  },
  data() {
    // this.cacheData = data.map((item) => ({ ...item }));
    return {
      frameworkOptions: [],
      frameworkOptionsList: [],
      itemIndex: 0,
      selectFrameWorkVal: '',
      frameworkTable: [],
      
      selectTag: { content: "" },
      frameworkList: [],
      cacheFrameWorkList: [],
      selectFrameWork: {},
      // widthImgDiv:"width:375px;height:812px",
      width: 0,
      height: 0,
      percent: 100,
      percentageList: [
        {
          id: 0,
          percent: 50,
        },
        {
          id: 0,
          percent: 75,
        },
        {
          id: 0,
          percent: 100,
        },
        {
          id: 0,
          percent: 125,
        },
        {
          id: 0,
          percent: 150,
        },
      ],
      phoneList: [
        {
          id: 0,
          phoneName: "iphone X",
        },
        {
          id: 1,
          phoneName: "iphone 6/7/8",
        },
        {
          id: 2,
          phoneName: "iphone 5/SE",
        },
        {
          id: 3,
          phoneName: "Apple TV",
        },
      ],
      sllectPhone: "iphoneX",
      isblock: false,
      tags: [],
      inputVisible: false,
      inputValue: "",
      columns,
      editingKey: "",
      ModalText: "Content of the modal",
      visible: false,
      confirmLoading: false,
      msg: {
        praiseNum: 0,
        downloadNum: 0,
        praiseflag: true,
        downloadflag: true,
      },
      code: "",
      cmOption: {
        tabSize: 2, // tab
        styleActiveLine: true, // 高亮选中行
        lineNumbers: true, // 显示行号
        styleSelectedText: true,
        line: true,
        foldGutter: true, // 块槽
        gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
        highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true }, // 可以启用该选项来突出显示当前选中的内容的所有实例
        mode: {
          // 模式, 可查看 codemirror/mode 中的所有模式
          name: "javascript",
          json: true,
        },
        // hint.js options
        hintOptions: {
          // 当匹配只有一项的时候是否自动补全
          completeSingle: false,
        },
        // 快捷键 可提供三种模式 sublime、emacs、vim
        keyMap: "sublime",
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: "base16-light", // 主题
        extraKeys: { Ctrl: "autocomplete" }, // 可以用于为编辑器指定额外的键绑定，以及keyMap定义的键绑定
      },
      editor: null,
      info: "低代码开发平台",
      iconTest: require("@/assets/component/detail/img_32417_0_1.png"),
      yonghu: require("@/assets/component/detail/img_32417_0_0.png"),
      text: "用户名",
      head__left_component_text: "组件分类：组件  表单",
      head__center_componentname_text: "组件名称：Form / Time selection",
      head__author_text: "作者：vivi",
      head__upload_time_text: "上传时间：2020-05-07",
      body__proportion_small_text: "375",
      body__take_text: "x",
      body__proportion_big_text: "812",
      body__format_text: "uniapp代码",
      switchBg: 1,
      component: {},
      value: 'console.log("hello,world")',
      componentRoute: "",
      //手机型号
      getSizeWidth: 0,
      getSizeHeight: 0,
      //盒子动态变化宽高
      activeWidth: null,
      activeHeight: null,
    };
  },
  computed: {
    // 仅读取
    widthImgDiv: function () {
      return {
        width: (this.width * this.percent) / 100 + "px",
        // height: (this.height * this.percent) / 100 + "px",
      };
    },
  },
  created() {
    let id = this.$route.query.projectId;
    console.log(id, "iddddd");
    projectApi.queryById({ id: id }).then((res) => {
      console.log("返回结果", res);
      this.getSize(JSON.parse(res.result.params));
    });
  },
  mounted() {
    this.component = this.$route.query;
    // 初始化图片预览
    this.selectPhone(this.phoneList[0]);
    // 获取框架信息
    this.getFrameWorkList(this.component.id);
    //初始化组件地址
    this.componentRoute = this.component.componentRoute;
    // console.log("component", this.componentRoute);

    //获取盒子大小
    this.$nextTick(() => {
      this.getBoxStyle();
      this.getBoxStyle2();
    });
    //监听body__left_select_div 的大小
    window.onresize = function () {
      let res = document
        .getElementsByClassName("body__left_select_div")[0]
        .getBoundingClientRect();
      let width = res.width;
      let height = res.height;
      this.activeWidth = width;
      this.activeHeight = height;
    };
    // console.log(this.activeWidth, this.activeHeight, ">>>>>");

    this.getFrameworkTree()
    console.log(this.component,'componentcomponent')
  },
  methods: {
    displayRender({ labels }) {
      return labels[labels.length - 1];
    },
    // 获取型号
    getSize(res) {
      let moblieModel = res.selectedSize.split(" ");
      console.log("modblie", moblieModel);
      this.getSizeWidth = parseInt(moblieModel[0]);
      this.getSizeHeight = parseInt(moblieModel[2]);
      console.log(this.getSizeWidth, "0000000000");
    },
    //获取bigImgDiv盒子大小
    getBoxStyle() {
      let { width, height } = document
        .getElementsByClassName("bigImgDiv")[0]
        .getBoundingClientRect();
      console.log("bigImgDiv", width, height);
      this.width = width;
      this.height = height;
    },
    //获取body__left_select_div盒子大小
    getBoxStyle2() {
      let { width, height } = document
        .getElementsByClassName("body__left_select_div")[0]
        .getBoundingClientRect();
      console.log("body__left_select_div", width, height);
      this.activeWidth = width;
      this.activeHeight = height;
    },
    copy: function () {
      this.message = this.componentRoute;
      this.$copyText(this.message).then(
        function () {
          alert("复制成功");
        },
        function () {
          alert("Can not copy");
        }
      );
    },
    editPage(pageId) {
      let { href } = this.$router.resolve({
        path: "/edit-page/",
        query: {
          pageId: pageId,
        },
      });
      window.open(href, "_blank");
    },

    getFrameWorkList(componentId) {
      frameworkApi
        .frameWorkSearch({
          componentId,
        })
        .then((res) => {
          console.log("res", res);
          this.frameworkList = res.result.records;
          if (this.frameworkList.length != 0) {
            this.selectFrameWork = this.frameworkList[0];
            this.changeFrameWork(this.selectFrameWork);
          }
        });
      console.log("componentid", componentId);
    },
    //返回
    returnClick() {
      console.log("返回");
      this.$router.go(-1);
    },
    //百分比选择
    selectPercentage(itemPercentage) {
      this.percent = itemPercentage.percent;
      console.log("this.percentage", this.percentage, itemPercentage.percent);
      // let num = this.percentage/100
      // console.log('num',num)
      // this.body__proportion_small_text = (this.body__proportion_small_text-0)*num
      // this.ody__proportion_big_text = (this.ody__proportion_big_text-0)*num
      // console.log('this.body__proportion_small_text',this.body__proportion_small_text)
    },
    //手机型号选择
    selectPhone(item) {
      console.log("aa", item);
      this.sllectPhone = item.phoneName;
      if (this.sllectPhone == "iphone X") {
        this.body__proportion_small_text = "375";
        // this.width =  this.body__proportion_small_text
        this.body__proportion_big_text = "812";
        this.width = 375;
        this.height = 812;
        // this.height = this.body__proportion_big_text
      }
      if (this.sllectPhone == "iphone 6/7/8") {
        this.body__proportion_small_text = "375";
        //  this.width =  this.body__proportion_small_text
        this.body__proportion_big_text = "667";
        this.width = 375;
        this.height = 667;
        // this.widthImgDiv = "width:375px;height:667px"
        // this.height = this.body__proportion_big_text
      }
      if (this.sllectPhone == "iphone 5/SE") {
        this.body__proportion_small_text = "320";
        //  this.width =  this.body__proportion_small_text
        this.body__proportion_big_text = "568";
        this.width = 320;
        this.height = 568;
        // this.height = this.body__proportion_big_text
      }
      if (this.sllectPhone == "Apple TV") {
        console.log(this.width, this.getSizeWidth, "=======");
        if (this.activeWidth < 1920) {
          this.body__proportion_small_text = "1920";
          this.body__proportion_big_text = "1080";
          this.width = 1920 * (this.activeWidth / this.getSizeWidth);
          this.height = 1080 * (this.activeWidth / this.getSizeWidth);
        }
      }
    },
    showtagInput(tag) {
      if (tag.name == "index.vue" || tag.name == "README.md") {
        this.$message.warning("该文件为内置文件，不可被编辑！");
        return;
      }
      tag.inputVisible = true;
      this.inputValue = tag.name;
    },
    //输入框内容变化时的回调
    tagInputChange(e) {
      this.inputValue = e.target.value;
      console.log("this.inputValue", this.inputValue);
    },
    //@blur 是当元素失去焦点时所触发的事件
    // keyup.enter 监听键盘回车事件
    tagInputConfirm(tag) {
      let self = this;
      tag.name = self.inputValue;
      codeApi.edit(tag).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          tag.inputVisible = false;
        } else {
          self.$message.warning(res.message);
          tag.inputVisible = false;
        }
      });
    },

    complectClick() {
      let self = this;
      if (self.selectTag.id == undefined) {
        self.$message.warning("请先选择一个文件！");
        return;
      }
      console.log("tag", self.selectTag);
      viewCodeExtApi.saveCode(self.selectTag).then((res) => {
        if (res.success) {
          self.$message.success(res.message);
        } else {
          self.$message.warning(res.message);
        }
      });
    },

    handleClose(removedTag) {
      let self = this;
      let id = removedTag.id;
      self.$confirm({
        title: "确认删除",
        content: "是否删除该代码文件?",
        onOk: function () {
          codeApi.delete({ id }).then((res) => {
            if (res.success) {
              self.$message.success(res.message);
              const tags = self.tags.filter((tag) => tag !== removedTag);
              console.log(tags);
              self.tags = tags;
            } else {
              self.$message.warning(res.message);
              self.changeFrameWork(self.selectFrameWork);
            }
          });
        },
      });
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(function () {
        this.$refs.input.focus();
      });
    },

    handleInputChange(e) {
      console.log("eeeeeeee", e);
      this.inputValue = e.target.value;
    },

    handleInputConfirm() {
      let self = this;
      const inputValue = self.inputValue;
      let tags = self.tags;
      let isRepeated = false;
      _.each(tags, (tag) => {
        if (tag.name == inputValue) {
          isRepeated = true;
        }
      });
      if (isRepeated) {
        this.$message.error("文件名不能相同！");
        return;
      }
      codeApi
        .add({
          name: inputValue,
          frameworkId: self.selectFrameWork.id,
        })
        .then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            Object.assign(this, {
              tags,
              inputVisible: false,
              inputValue: "",
            });
            self.changeFrameWork(self.selectFrameWork);
          } else {
            self.$message.warning(res.message);
          }
        });
    },

    handleAdd() {
      let self = this
      if ( this.selectFrameWorkVal == '') {
        return
      }
      let { id } = this.selectFrameWorkVal
      frameworkApi.frameWorkAdd({ 
        componentId: self.component.id,
        frameworkId: id
      }).then(() => {
        this.getFrameWorkList(self.component.id)
      })
    },

    setFrameWork(val,option) {
      this.selectFrameWorkVal = option[option.length - 1]
    },

    handleChange(value, id, column) {
      const newData = [...this.frameworkList];
      const target = newData.filter((item) => id === item.id)[0];
      if (target) {
        target[column] = value;
        this.frameworkList = newData;
      }
    },
    editFrameWork(id) {
      const newData = [...this.frameworkList];
      const target = newData.filter((item) => id === item.id)[0];
      this.editingKey = id;
      if (target) {
        target.editable = true;
        this.frameworkList = newData;
      }
    },
    deleteFrameWork(id) {
      // TODO 删除框架
      let self = this;
      self.$confirm({
        title: "确认删除",
        content: "是否删除选中数据?",
        onOk: function () {
          frameworkApi.frameWorkDelete({ id }).then((res) => {
            self.getFrameWorkList(self.component.id)
          });
        },
      });
    },

    getFrameworkTree() {
      frameworkApi.listAll().then(res => {
        this.frameworkOptionsList = res.result
        let frameworkOptions = {id: null}
        this.getChildren(frameworkOptions)
        this.frameworkOptions = frameworkOptions.children
        console.log(this.frameworkOptions,'this.frameworkOptions');
        // _(res.result).filter(item => tem.parentId == null).each
      })
    },
    getChildren(obj){
      obj.children = _.filter(this.frameworkOptionsList, item => item.parentId == obj.id)
      if(obj.children.length > 0){
        obj.children.forEach(item => {
          this.getChildren(item)
        })
      }
    },

    changeFrameWork(framework) {
      console.log('framework', framework)
      let self = this;
      self.selectFrameWork = framework;
      // TODO 查询该框架下所有的文件
      viewCodeExtApi
        .listAll({
          componentFrameworkId: framework.id,
        })
        .then((res) => {
          if (res.result.length != 0) {
            _.each(res.result, (item, index) => {
              item.inputVisible = false;
            });
            self.tags = res.result;
            self.selectTag = res.result[0];
            this.changeTag(self.selectTag);
          } else {
            self.selectTag = {
              content: "",
            };
            self.tags = [];
          }
        });
    },
    changeTag(tag) {
      this.selectTag = tag;
      this.itemIndex = tag.id;
    },
    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.ModalText = "The modal will be closed after two seconds";
      this.confirmLoading = true;
      setTimeout(() => {
        this.visible = false;
        this.confirmLoading = false;
      }, 2000);
    },
    handleCancel() {
      console.log("Clicked cancel button");
      this.visible = false;
    },
    // 点赞加1
    praiseAdd() {
      // this.praiseNum++
      this.msg.praiseNum = this.msg.praiseflag
        ? this.msg.praiseNum + 1
        : this.msg.praiseNum - 1;
      this.msg.praiseflag = !this.msg.praiseflag;
    },
    // 下载量加1
    downloadAdd() {
      // this.downloadNum++
      this.msg.downloadNum = this.msg.downloadflag
        ? this.msg.downloadNum + 1
        : this.msg.downloadNum - 1;
      this.msg.downloadflag = !this.msg.downloadflag;
    },
    onCmReady3() {
      this.$refs.myCmGenerate.codemirror.setSize("57vw", "35vw");
    },
    onCmFocus(instance, event) {
      console.log(instance);
      console.log(event);
      console.log("获取焦点");
      this.isblock = !this.isblock;
    },
    onCmCodeChange(instance, obj) {
      console.log(instance);
      console.log(obj);
    },
    snapshot(id){
      componentApi.componentSnapshot({ id: id }).then((res) => {
        console.log("返回结果", res);
        if (res.success) {
          this.$message.success("操作成功");
        } else {
          self.$message.warning(res.message);
        }
      });
    },

    // switchClick(status) {
    //   if (status == 1) {
    //     this.switchBg = 1;
    //   } else {
    //     this.switchBg = 2;
    //   }
    // },
  },
};
</script>
<style lang="less" scoped>
@import "./index.css";

/deep/ .ant-btn {
  width: 200px;
  height: 50px;
  font-size: 16px;
}
/deep/ .ant-btn-primary {
  width: 150px;
  height: 50px;
  font-size: 16px;
  background-color: #4d8fff;
  border-color: #4d8fff;
}

/deep/ .ant-btn span {
  font-size: 18px;
}
/deep/ .ant-btn-primary {
  width: 10.417vw;
}
.ant-btn-button:hover {
  border-color: #4d8fff;
  color: #4d8fff !important;
}
.page__details {
  --antd-wave-shadow-color: #4d8fff;
}
#container {
  text-align: left;
}
.Active {
  color: red !important;
}

.CodeMirror-scroll {
  overflow: scroll !important;
  margin-bottom: 0;
  margin-right: 0;
  padding-bottom: 0;
  height: 100%;
  outline: none;
  position: relative;
  border: 1px solid #dddddd;
  box-sizing: border-box;
}

.code-mirror {
  width: 100%;
  height: 100%;
  background-color: rgb(245, 245, 245);
  // margin: 0.5vw 0.5vw 0vw 0.5vw;
  font-size: 18px;
  line-height: 150%;
  text-align: left;
}

/deep/ .cm-s-base16-light span.cm-error {
  background: none;
}

/deep/ .ant-tag {
  // background-color: #2878ff;
  width: 140px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  margin-top: 3px;
  margin-bottom: 3px;
  // color: #ffffff;
}

.code-mirror /deep/ .CodeMirror {
  width: 100% !important;
  height: 100% !important;
  max-height: 1050px;
  overflow: hidden;
  // height: auto !important;
}
.head__download_div:hover,
.head__praise_div:hover,
.add_tag-style:hover,
.tag-class:hover {
  cursor: pointer;
}
</style>